import script from "./landing-companies.vue?vue&type=script&setup=true&lang=ts"
export * from "./landing-companies.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__